import axios from 'axios'
import { NavigateFunction } from 'react-router-dom'
import errorHandler from './error-handler'

const axiosClient = (token: string, navigate?: NavigateFunction) => {
  const instance = axios.create({
    headers: {
      'content-type': 'application/json',
    },
  })
  instance.interceptors.request.use(
    async (config) => {
      const temp = config
      temp.headers.Authorization = `Bearer ${token}`
      return temp
    },
    async (error) => Promise.reject(error)
  )
  instance.interceptors.response.use(
    (response) =>
      // message.success("Success"); //xử lý success ở đây ko đc vì ko xác định đc method của request, nên phải xử lý bên gọi hàm
      response,
    (error) => {
      const status = error.response.data.statusCode
      const responseMessage = error.response.data.message
      // errorHandler(status, responseMessage, navigate)
      return error.response
    }
  )
  return instance
}

export default axiosClient
